const firstTimeModalNewVerificationCode = {
  'first-time-modal-new-verificaion-code-message': 'Wir haben Ihnen einen neuen Verifizierungscode gesendet. Bitte öffnen Sie Ihre E-Mails und schließen Sie die Verifizierung ab. Vielen Dank, dass Sie uns gewählt haben.'
};

export default firstTimeModalNewVerificationCode;
